import React from "react"
import mount from "core/mount"
import { LinkButton } from "@kit/design/link-button"
import { Note } from "@kit/design/note"

function UnconfirmedUserEmailBanner({ emailSettingsLink }) {
  return (
    <Note variant="warning" layout="inline">
      <Note.Icon />
      <Note.Content>
        <p>
          <strong>Confirm your email to finish setting up your account.</strong>{" "}
          We&apos;ve sent a confirmation link to your sign-up address.
        </p>
      </Note.Content>
      <Note.Actions>
        <LinkButton size="small" href={emailSettingsLink} target="_blank">
          Manage email address
        </LinkButton>
      </Note.Actions>
    </Note>
  )
}

export { UnconfirmedUserEmailBanner }

mount({ "Account.UnconfirmedUserEmailBanner": UnconfirmedUserEmailBanner })
